module.exports = __webpack_public_path__ + "img/img-subscribe@2x.b51a48c.jpg";